/* 
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */
if(!window.GS) GS={};
GS.Toolbar=new Class({
    Extends: GS.BaseClass,
    class_name:'GS.Toolbar',
    options:{
        'obj_type':'toolbar',
        'stage': null,
        'defaults':['close'],
        'raphael':false,
        'active_area':10,
        'wrapper':'body',
        'workarea_wrapper': '#centro',
        'toolbar_class':'frame_toolbar',
        'grabber_width': 14,
        'geometry':{
            'rotation': 0,
            'x':0,
            'y':0,
            'width':100,
            'height':50,
            'fill': "#f0f0f0",
            'stroke': '#ccc',
            'stroke-width':2
        }
    },
    ww:null,
    linkedTo:null,
    toolbar:null,
    status:'hidle',
    svg:null,
    svgWrapper:null,
    initialize:function(paper,conf){
        this.parent(conf);
        this.svg=paper.canvas;
        this.svgWrapper=this.svg.parentNode;
        this.register('spread:new',this.hide.bind(this));
        this.register('active:frame',this.attach.bind(this));
        this.register('no:selection',this.attach.bind(this));
        //this.register('toolbaronly:active:frame',this.attach.bind(this));
        this.register('toolbar:force:show',this.attach.bind(this));
        //TODO: add listener for window scroll/resize events to permit toolbar position update....
        //window.addEvent('resize',this.updatePosition.bind(this));
        this.addEvent('show',this.show.bind(this));
        this.addEvent('hide',this.hide.bind(this));

        window.addEvent('resize',function(){
            this.dispatch('active:frame',null);
        }.bind(this));

        let mainContainer = document.querySelector('.svg_cont') || this.svg.parentNode;

        mainContainer.addEventListener('click', function(e){
            if(e.target.ownerSVGElement || e.target === this.svg) return;
            //console.warn('CLICK ON SVG PARENT.PARENT NODE. CALL UNSELECT ELEMENTS!', e.target);
            this.dispatch('active:frame', null);
        }.bind(this))

        mainContainer.addEventListener('keydown', function(e){
            this.dispatch('active:frame', null);
        }.bind(this))

        /*this.svg.parentNode.parentNode.addEventListener('click', function(e){
            console.warn('CLICK ON SVG PARENT.PARENT NODE. CALL UNSELECT ELEMENTS!', e.target);
           // this.dispatch('active:frame', null);
        }.bind(this))*/



        this.register('toolbar:hide:submenues', function(){
            this.fireEvent('submenu:show',null);
        }.bind(this));



        this.drawToolbar(paper);
        
    }
});

/***
 * 
 * @param {type} ele
 * @returns {void}
 */
GS.Toolbar.prototype.drawToolbar=function(ele){
    var self=this;
    
    this.ww=$(document.body).getElement(this.options.workarea_wrapper);
    if(this.ww) {
        //window.addEvent('resize',this.updatePosition.bind(this));
        this.ww.addEvent('scroll',this.updatePosition.bind(this));
    }
    this.toolbar=$(document.body).getElement('.'+this.options.toolbar_class);
    if(!this.toolbar){
        this.toolbar=new Element('div',{'class':this.options.toolbar_class}).set('html',this.toolbarTMPL());
        $(document.body).adopt(this.toolbar);
        this.configureToolbar();
        this.toolbar.setStyle('display','none');
        this.register('spread:new',function(){
            self.linkedTo = null;
            self.toolbar.setStyle('display','none');
        });

        this.register('toolbar:force:hide',function(s){
          self.hide();
        })

        this.register('toolbar:toggle',function(s){
            (self.linkedTo && !s) ? self.show() :  self.hide();
            //if(self.linkedTo && !s)
            if(s === 'hide') self.hide();
            self.updatePosition();
        });
    }
};

/*
GS.Toolbar.prototype.addUserInteraction=function(type,ele){};
*/


/**
 * 
 * @returns {void}
 */
GS.Toolbar.prototype.configureToolbar=function(){
    var self=this,/*btns=this.toolbar.getElements('li:first-child');*/
    btns=this.toolbar.getElement('.frame-tools').getChildren();
    //Add event delegation to the toolbar object!
    var mainMenues=[];
    var type,cls,clsOpts;
    //Configure toolbar buttons with defaults behaviors
    Array.each(btns,function(ele,i){
        type=ele.getAttribute('data-type');
        cls = null;
        switch(type){
            case 'effects-menu':
                cls = GS.Toolbar.Image.ColorsTools;
                clsOpts = {'debug':0,'wrapper':ele,'type':type,'permission_property':'effects'};
            break;
            case 'framebackground-tools':
                cls = GS.Toolbar.Frame.BackgroundTools;
                clsOpts = {'debug':0,'wrapper':ele,'type':type,'permission_property':['background-color']};
            break;
            case 'shadow-menu':
                cls = GS.Toolbar.Frame.ShadowTools;
                clsOpts = {'debug':0,'wrapper':ele,'type':type,'permission_property':'shadow'};
            break;
            case 'inner-shadow-menu':
                cls = GS.Toolbar.Frame.InnerShadowTools;
                clsOpts = {'debug':0,'wrapper':ele,'type':type,'permission_property':'inner-shadow'};
                break;
            case 'fit-menu':
                cls = GS.Toolbar.Frame.FitTools;
                clsOpts = {'debug':0,'wrapper':ele,'type':type,'permission_property':'fit'};
            break;
            case 'align-menu':
                cls = GS.Toolbar.Image.AlignTools;
                clsOpts = {'debug':0,'wrapper':ele,'type':type,'permission_property':'align'};
            break;
            case 'image-menu':
                cls = GS.Toolbar.Image.GeometryTools;
                clsOpts = {'debug':0,'wrapper':ele,'type':type,'permission_property': 'image'};
            break;
            case 'zindex-menu':
                cls = GS.Toolbar.Frame.LevelsTools;
                clsOpts = {'debug':0,'wrapper':ele,'type':type,'permission_property':'zIndex'};
            break;
            case 'text-tools':
                cls = GS.Toolbar.Text.Tools;
                clsOpts = {'debug':0,'wrapper':ele,'type':type,'permission_property':'text'};
            break;
            case 'border-tools':
                cls = GS.Toolbar.Frame.BordersTools;
                clsOpts = {'debug':0,'wrapper':ele,'type':type,'permission_property':'stroke'};
            break;
            case 'border-effects':
                cls = GS.Toolbar.Frame.ObjectEffects;
                clsOpts = {'debug':0,'wrapper':ele,'type':type,'permission_property':['colorizebackground','mask-effects','object-effects']};
            break;
            case 'dualtone-effects':
                cls = GS.Toolbar.Frame.DualtoneEffects;
                clsOpts = {'debug':0,'wrapper':ele,'type':type,'permission_property': 'dualtone'};
            break;
            case 'settings-menu':
                cls = GS.Toolbar.Frame.SettingsTools;
                clsOpts = {'debug':0,'wrapper':ele,'type':type,'permission_property': 'settings_off'};
            break;
            case 'wallart-frameborder':
                if(window.riot && window.getProduct && window.getProduct() === 'WALLART') riot.mount('gs-wallartframeborder', {'language' : (window.getUserLanguage() || 'it')});
                break;
            case 'wallart-bordertype':
                if(window.riot && window.getProduct && window.getProduct() === 'WALLART' && window.getCustomerCode && window.getCustomerCode() === 0) riot.mount('gs-wallartborder', {'language' : (window.getUserLanguage() || 'it')});
                break;
            default:
                if(type){
                    cls = GS.Toolbar.Tool;
                    clsOpts = {'debug':0,'wrapper':ele,'type':type,'permission_property':type};
                }
            break;
        }
        
        if(cls){
            cls = new cls(clsOpts);
            cls.attachToToolbar(self);
            return;
        }
        
    });
};

/**
 * 
 * @param {type} ele
 * @returns {void}
 */
GS.Toolbar.prototype.attach=function(ele){
     var fx,  specials;
     //console.log('ATTACH TOOLBAR TO', ele);
     specials = ['cover', 'material','youngbox-internal', 'youngbox-external','youngbox-external-cover'];
    if(!ele /*|| !ele.ele*/) {
        //console.warn('HIDE....');
        //this.toolbar.setStyle('display','none');
        this.linkedTo=null;
        this.hide();
        return;
    }
    fx=(ele.getEffects) ? ele.getEffects() : {'zoom':0,'shadow':null,'effects':null};


    if(ele && ele.options && ele.options['frame-type'] === 'multi') {
        this.linkedTo=ele;
        this.updatePosition(null);
        this.show();
        return;
    }
    
    if(ele && ele.options && (ele.options.bgtype || specials.indexOf(ele.options['frame-type']) !== -1 /*|| ele.options['frame-type'] === "text"*/)){
        this.toolbar.removeAttribute('data-float');
    }else{
        this.toolbar.setAttribute('data-float','right');
    }


    if(ele){

        this.linkedTo=ele;
        this.updatePosition(ele.getScreenPosition());
        if( specials.indexOf(ele.options['frame-type']) !== -1) this.show();
    }
    //Hide submenues...
    this.fireEvent('submenu:show',null);
};

/**
 * 
 * @returns {void}
 */
GS.Toolbar.prototype.show=function(){
    this.toolbar.setStyle('display','block');
};

/**
 * 
 * @returns {void}
 */
GS.Toolbar.prototype.hide=function(){
    this.toolbar.setStyle('top','-1000px');
    this.fireEvent('submenu:show',null);
    this.toolbar.dataset.frame = GS.Utility.spreadInfo ? GS.Utility.spreadInfo.type : 'unknow';
    this.toolbar.dataset.matted = ("isMatted" in window && window.isMatted());
};

/**
 * 
 * @param {type} p
 * @returns {void}
 */
GS.Toolbar.prototype.updatePosition=function(p){

    //console.debug(this.linkedTo, p);
    if(!p && !this.linkedTo) return;
    if(!p && this.linkedTo && this.linkedTo.getScreenPosition) p=this.linkedTo.getScreenPosition();
    let ghostSelection = document.getElementById('ghost-selection');

    //console.warn('P', p);
    //console.warn('GHOST SELECTION', ghostSelection);

    if(ghostSelection && ghostSelection.children.length > 1) {
        p = ghostSelection.getBoundingClientRect();
        //console.info('UPDATE TOOLBAR POS USING THE GHOST SELECTION', p);
    }
    if(!p) return;

    var svgBB = this.svg.getBoundingClientRect(),
        wDim = {'width':document.documentElement.clientWidth,'height':document.documentElement.clientHeight},
        tposX,tposY;
    
    tposX = (p.left+p.width+15);
    tposY = (p.top-10);

    //console.warn('SVG BBOX:', svgBB);
    //console.warn('(BEFORE) TOOLBAR X: %s Y: %s', tposX, tposY);

    if(!window.getProduct || ['WALLART','MEGA_MATS','MAT','MATS'].indexOf(window.getProduct()) === -1) {
       /* if (tposX < svgBB.left) tposX = svgBB.left;
        if (tposX > svgBB.right) tposX = svgBB.right;
        if (tposY < svgBB.top) tposY = svgBB.top;
        if (tposY > svgBB.bottom) tposY = svgBB.bottom;*/
        tposX = (p.left+p.width+8);
    }else{
        tposX = (p.left+p.width+2);
    }

    //console.warn('(AFTER) TOOLBAR X: %s Y: %s', tposX, tposY);

    if(this.toolbar.getAttribute('data-float')){
        if(tposX+320>wDim.width && !this.linkedTo.isWallArtFrame && !this.linkedTo.isMegaMatsFrame){
            tposX = p.left-90;
            //tposX -= 16;
            this.toolbar.setAttribute('data-float','left');
        }else{
            this.toolbar.setAttribute('data-float','right');
        }
        //console.log(this.toolbar.querySelector('.frame-tools').getBoundingClientRect(), wDim);
        this.toolbar.setStyles({'left':tposX+'px','top':tposY+'px'});
        return;
    }else{
        tposX = p.left+(p.width*.5)-36;
        tposY = (svgBB.top-54);
        this.toolbar.setStyles({'left':tposX+'px','top':tposY+'px'});
        return;
    }
};

/**
 * Return the HTML Toolbar template
 * @returns {String} out;
 */
GS.Toolbar.prototype.toolbarTMPL=function(){
    var product, out;
    product = window.getProduct();
    console.warn('TOOLBAR: PRODUCT ID', product);
    out='<ul class="frame-tools">';
    //out+='<li><gs-personalizations-compatpanel dispatch="personalization:set"></gs-personalizations-compatpanel></li>';
    if(['YOUNG BOOK', 'WEDDING BOOK', 'STORY BOOK','GO BOOK','GOBOOK','GO-BOOK'].indexOf(product) !== -1) out+='<li><gs-personalizations></gs-personalizations></li>';
    out+='<li class="content-image" data-type="image-menu" title="{image_menu}"></li>';

    out+='<li class="background-menu" data-type="framebackground-tools" title="{framebackground_menu}">';
    out+='</li>';
    
    //out+='<li class="zindex-menu" data-type="zindex-menu"></li>';
    
    out+='<li class="content-align" data-type="align-menu" title="{align_menu}"></li>';
    out+='<li class="frame-fit" data-type="fit-menu" title="{fit_menu}"></li>';
    out+='<li class="zindex-menu" data-type="zindex-menu" title="{levels_menu}"></li>';
    out+='<li class="border-tools" data-type="border-tools" title="{stroke_menu}"></li>';
    out+='<li class="border-tools colors" data-type="border-effects" title="{strokeeffects_menu}"></li>';



    out+='<li class="border-tools colors" data-type="dualtone-effects" title="{strokeeffects_menu}"></li>';
    
    out+='<li class="text-tools" data-type="text-tools" data-uitype="btns"></li>';
    out+='<li class="box-shadow" data-type="shadow-menu" title="{shadow_menu}"></li>';
    out+='<li class="box-inner-shadow" data-type="inner-shadow-menu" title="{inner_shadow_menu}"></li>';
    out+='<li class="effects-menu" data-type="effects-menu" title="{effects_menu}"></li>';
    out+='<li class="settings-menu" data-type="settings-menu" title="{settings_menu}"></li>';
    out+='<li class="syncbackground" data-type="autosyncbackgrounds" data-uitype="btn" title="{syncbackground_btn}"></li>';

    if(window.getProduct && window.getProduct() === 'WALLART') {
        out += '<li data-type="wallart-frameborder"><gs-wallartframeborder locale="' + (window.getUserLanguage ? window.getUserLanguage() : 'en') + '"></gs-wallartframeborder></li>';
        //out += '<li data-type="wallart-bordertype"><gs-wallartborder locale="' + (window.getUserLanguage ? window.getUserLanguage() : 'en') + '"></gs-wallartborder></li>';
    }

    //out+='<li class="s" data-type="delete" data-uitype="btn" title="{delete_btn}"></li>';

    out+='<li class="delete" data-type="delete" data-uitype="btn" title="{delete_btn}"></li>';
    out+='</ul>';
    out=out.substitute(Locale.get('Toolbar.general'));
    
    return out;
};
